/*
 * Created by alex@hackerbay.com on 3.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Container,Button, Card, CardBody, Col, Media, Row} from "reactstrap";
import Subtitle from "./Subtitle";

import iconPackageWhite from "../media/icons/package-white.png"
import iconPackageBlack from "../media/icons/package-black.png"
import iconShipperGls from "../media/icons/shipper-gls.png"
import iconShipperDhl from "../media/icons/shipper-dhl.png"
import {PackageTrackingStatus} from "../packageTrackingStatus";
import {hardwareWasDelivered} from "../hardwareHelper";


const DELIVERY_STATUS = {
    DELIVERED: "Delivered_001"
};
class RouterShipmentTrackingBox extends React.Component {
    DELIVERY_COMPANIES = {
        DHL: {
            logo: iconShipperDhl,
            icon: iconPackageBlack,
            shipperClass: "shipper-dhl",
            trackingButtonColorClass: "button-dark-gray"
        },
        GLS: {
            logo: iconShipperGls,
            icon: iconPackageWhite,
            shipperClass: "shipper-gls",
            trackingButtonColorClass: "button-white"
        }
    };
    constructor(props) {
        super(props);
        this.state = {
            deliveryCompanyStyles: this.getDeliveryCompanyStylesFromOrderStatus(props.orderStatus)
        }
    }


    getDeliveryCompanyStylesFromOrderStatus = (orderStatus) => {
        if(orderStatus.shipping.trackingLink.toLowerCase().indexOf("dhl") > -1){
            return this.DELIVERY_COMPANIES.DHL;
        }
        return this.DELIVERY_COMPANIES.GLS;

    };

    packageTrackingOnClick = () => {
        window.open(this.props.orderStatus.shipping.trackingLink);
    };

    render() {
        let daysUntilDeliveryTextResource;
        const daysUntilDelivery = this.props.orderStatus.shipping.daysUntilExpectedDeliveryDate;
        if(hardwareWasDelivered(this.props.orderStatus)){
            daysUntilDeliveryTextResource = "router_was_delivered";
        } else if(daysUntilDelivery){
            if(daysUntilDelivery > 1){
                daysUntilDeliveryTextResource = "router_will_arrive_in_x_days";
            }else{
                daysUntilDeliveryTextResource = "router_will_arrive_today";
            }
        }else{
            daysUntilDeliveryTextResource = "router_was_shipped_title";
        }

        return <Container className={"shadow round-corners shipment-tracking-box " + this.state.deliveryCompanyStyles.shipperClass}>
            <Row>
                <Col xs={2}>
                    <img src={this.state.deliveryCompanyStyles.icon} style={{height:"28px",width:"28px"}}/>
                </Col>
                <Col xs={10} style={{paddingLeft:"0px"}}>
                    <p className={'text-shipment-tracking-box'}>{i18n.t(daysUntilDeliveryTextResource, {count: this.props.dayCountUntilDelivery})}</p>
                </Col>
            </Row>
            <Row style={{marginTop:"6px"}}>
                <Col xs={5}>
                    <img src={this.state.deliveryCompanyStyles.logo} className={"img-fluid"} style={{marginTop:"12px"}}/>
                </Col>
                <Col xs={7}>
                    <Button style={{height:"48px"}}
                            className={"w-100 " + this.state.deliveryCompanyStyles.trackingButtonColorClass}
                            onClick={this.packageTrackingOnClick}>{i18n.t("package_tracking")}</Button>
                </Col>
            </Row>
        </Container>
    }
}

export default translate("translations")(RouterShipmentTrackingBox);
export {DELIVERY_STATUS}